export default __webpack_public_path__ + "static/banner_back-02e0c9bf2ead49baa2612d804215fd02.webp";